import * as Sentry from '@sentry/react';

import { env } from '@/env';

Sentry.init({
  dsn: env.SENTRY_DSN,
  debug: false,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [],
});
